document.addEventListener('variant:update', (event) => {
  const variant = event.detail?.resource;
  const variantId = variant ? String(variant.id) : null;

  document.querySelectorAll('.product-shipping--pdp').forEach((container) => {
    let hasVisible = false;
    let activeShippingType = '';

    container.querySelectorAll('[data-shipping-type][data-variant-ids]').forEach((el) => {
      const ids = variantId && el.dataset.variantIds ? el.dataset.variantIds.split(',') : [];
      const visible = ids.includes(variantId);
      el.style.display = visible ? '' : 'none';
      if (visible) {
        hasVisible = true;
        activeShippingType = el.dataset.shippingType || '';
      }
    });

    container.style.display = hasVisible ? '' : 'none';

    if (activeShippingType) {
      container.dataset.activeShippingType = activeShippingType;
    } else {
      container.removeAttribute('data-active-shipping-type');
    }
  });
});
